import CoachingLanding from "@/components/landing/CoachingLanding";
import SectionTracker from "@/components/analytics/SectionTracker";
import { usePageMeta } from "@/lib/brand";
import { useLayoutEffect, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const Index = () => {
  usePageMeta({
    title: "Decorum Lifestyle — Forge the Man God Called You to Be",
    description:
      "Private coaching with Lance Ehlers for men building discipline, wealth and character.",
    path: "/",
  });
  // Landing page uses its original light theme — strip the global `dark` class
  // that App.tsx applies to prevent flash on authenticated routes.
  useLayoutEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains("dark");
    root.classList.remove("dark");
    return () => {
      if (hadDark) root.classList.add("dark");
    };
  }, []);

  // Log a landing-page visit once per mount. Fire-and-forget; never blocks render.
  useEffect(() => {
    const key = "decorum_landing_logged_session";
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    supabase.functions
      .invoke("log-landing-visit", {
        body: { path: "/", referrer: document.referrer || null },
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-background text-foreground">
      <main>
        <SectionTracker name="coaching_landing">
          <CoachingLanding />
        </SectionTracker>
      </main>
    </div>
  );
};

export default Index;
